import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import { Container, Row } from "react-bootstrap";

//Services
import api from "../../../service/api";

//Routes
import routes from "../../../routes/campaigns.routes";

//Components
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Main from "../../../components/Main";
import Table from "../../../components/Table";
import DropdownButton from "../../../components/DropdownButton";
import SideContainer from "../../../components/SideContainer/styles";
import SideForm from "../../../components/SideForm";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import ModalSuccessMessage from "../../../components/ModalSuccessMessage";

//Styles
import {
    THead,
    Th,
    ThFilterable,
    Td
} from "./styles";

//Helpers Functions
import { openModal } from "../../../helpers/modalFunctions";

//Interfaces
import { CampaignsList } from "./interfaces";

//Assets
import ListIcon from "../../../assets/icons/plans-hover.svg";

const data = [
    {
        id: "1",
        description: "Teste",
        amount: 5000
    },
    {
        id: "2",
        description: "Teste2",
        amount: 8000
    },
    {
        id: "3",
        description: "Teste3",
        amount: 10000
    },
    {
        id: "4",
        description: "Teste4",
        amount: 2000
    },
]

const Campaign = () => {
    const [campaignList, setCampaignList] = useState<CampaignsList[]>([]);
    const [isSideFormVisible, setIsSideFormVisible] = useState(false);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const login = useSelector((state: {login: any}) => state.login);

    useEffect(() => {
        const getCampaignsAtApi = async () => {
            const { data } = await api.get("donations/camp/list", {
                params: {
                    sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
                    page
                }
            });

            setCampaignList(data.donationsCamp)
        }

        getCampaignsAtApi();
    }, [page]);

    useEffect(() => {
        const timerId = setTimeout(() => {
            setPage(1);
            setDebouncedSearchTerm(searchTerm);
        }, 1000);
    
        return () => {
            clearTimeout(timerId);
        }
    }, [searchTerm]);

    useEffect(() => {
        const getFilteredCampaignsAtApi = async () => {
            const { data } = await api.get("donations/camp/list", {
                params: {
                    sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
                    search: debouncedSearchTerm,
                    page
                }
            });

            setCampaignList(data.donationsCamp)
        }
        
        if(debouncedSearchTerm !== ""){
            getFilteredCampaignsAtApi();
        }
    }, [debouncedSearchTerm]);

    const reactiveCampaign = async (id: string) => {
        try {
            await api.put("donations/camp/update", {
                id,
                active: true
            });

            const { data } = await api.get("donations/camp/list", {
                params: {
                    sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
                    page
                }
            });

            setCampaignList(data.donationsCamp)
            
        } catch (error) {
            
        }
    }

    const suspendCampaign = async (id: string) => {
        try {
            await api.put("donations/camp/update", {
                id,
                active: false
            });

            const { data } = await api.get("donations/camp/list", {
                params: {
                    sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
                    page
                }
            });

            setCampaignList(data.donationsCamp);
        } catch (error) {
            
        }
    }

    const generateTableRows = () => {
        return campaignList.map(item => {
            return(
                <tr key={item.id}>
                    <Td>{item.description}</Td>
                    <Td>{item.active ? "ATIVO" : "INATIVO"}</Td>
                    <Td>R$ {(parseFloat(item.amount) / 100).toLocaleString("pt-br", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</Td>
                    <Td>
                        <DropdownButton 
                            isSubscription 
                            subscriptionStatus={item.active ? "active" : ""}
                            reactiveSubscription={() => reactiveCampaign(item.id)} 
                            suspendSubscription={() => suspendCampaign(item.id)}
                        />
                    </Td>
                </tr>
            )
        })
    }
    
    return(
        <Container fluid>
            <ModalSuccessMessage text="Campanha adicionada com sucesso"/>
            <Row>
                <Main
                    className= {`${isSideFormVisible ? "col-d-none column-side-open" : "column-content"}`}
                    isFormVisible={isSideFormVisible}
                >
                    <Header title="Campanhas" subTitle="Crie e gerencie campanhas e acompanhe as doações" subTitleWidth={271}/>
                    <NavTabs tabs={routes}/>
                    
                    <Table
                        page={page}
                        maximumPage={1}
                        setPage={setPage}
                        buttonText="Adicionar Campanha"
                        showAddButton={true}
                        showExportButton={true}
                        setIsAddFormVisible={() => setIsSideFormVisible(true)}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                    >
                        <THead>
                            <tr>
                                <Th>Descrição</Th>
                                <Th>Status</Th>
                                <Th>Valor</Th>
                                <Th></Th>
                            </tr>
                        </THead>

                        <tbody>
                            { generateTableRows() }
                        </tbody>
                    </Table>

                </Main>

                <SideContainer visible={isSideFormVisible} className="column-side">
                    <SideForm 
                        title="Adicionar campanha"
                        icon={ListIcon}
                        visible={() => setIsSideFormVisible(false)}
                    >
                        <Formik
                            initialValues={{
                                description: "",
                                amount: ""
                            }}
                            onSubmit={ async ( values, { resetForm } ) => {
                                values.amount = parseFloat(values.amount.replace(",", ".")).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})
                                const amountHaveDot = values.amount.includes(".");
                                let amountInCents;
                                
                                if(amountHaveDot){
                                    amountInCents = parseFloat(values.amount.replace(",", ".").replaceAll(".", ""));
                                }
                                
                                else {
                                    amountInCents = parseFloat(values.amount.replace(",", ".")) * 100;
                                }

                                try {
                                    const response = await api.post("/donations/camp/create", {
                                        sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
                                        description: values.description,
                                        amount: amountInCents
                                    });

                                    if(page === 1){
                                        const { data } = await api.get("donations/camp/list", {
                                            params: {
                                                sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
                                                page: 1
                                            }
                                        });
                            
                                        setCampaignList(data.donationsCamp);
                                    }
                                    
                                    else {
                                        setPage(1);
                                    }

                                    resetForm();
                                    openModal("exampleModal")
                                } catch (error) {
                                    
                                }

                            }}
                        >
                            <Form style={{ width: "100%", marginTop: 41 }}>
                                <Field 
                                    id="description" 
                                    name="description" 
                                    placeholder="Descrição" 
                                    className="inputCustom"
                                    as={Input}
                                />
                                <Field 
                                    id="amount" 
                                    name="amount" 
                                    placeholder="Valor" 
                                    className="inputCustom"
                                    as={Input}
                                />

                                <Button 
                                    type="submit"
                                    className="buttonCustom"
                                >
                                    Adicionar
                                </Button>
                            </Form>
                        </Formik>

                    </SideForm>
                </SideContainer>
            </Row>
        </Container>
    )
}

export default Campaign;